import { Outlet } from 'react-router';
import { RoutesConfig } from 'shell/router/routes-config';
import { NotFound } from 'shell/error/components/error-not-found';
import { CancellationDeathAuthorizations } from 'shell/authorizations/cancellations';
import CancellationAireCitizenshipLossSearchPersonPage from 'cancellations/pages/cancellation-aire/citizenship-loss/search';
import CancellationAireLossCitizenshipPage from 'cancellations/pages/cancellation-aire/citizenship-loss/cancellation';
import CancellationAirePresumedUnavailabilitySearchPersonPage from 'cancellations/pages/cancellation-aire/presumed-unavailability/search';
import CancellationAirePresumedUnavailabiltyPage from 'cancellations/pages/cancellation-aire/presumed-unavailability/cancellation';

export const cardRoutes: RoutesConfig = [
  {
    name: 'Cancellazione AIRE',
    path: '/cancellazione-aire',
    element: <Outlet />,
    hidden: true,
    children: [
      {
        path: '',
        hidden: true,
      },
      {
        path: '/perdita-cittadinanza',
        name: 'Perdita Cittadinanza Italiana',
        authorizations: CancellationDeathAuthorizations,
        element: <Outlet />,
        children: [
          {
            path: '',
            element: <CancellationAireCitizenshipLossSearchPersonPage />,
          },
          {
            path: '/cancellazione',
            element: <CancellationAireLossCitizenshipPage />,
          },
        ],
      },
      {
        path: '/irreperibilita-presunta',
        name: 'Irreperibilità Presunta',
        authorizations: CancellationDeathAuthorizations,
        children: [
          {
            path: '',
            element: <CancellationAirePresumedUnavailabilitySearchPersonPage />,
          },
          {
            path: '/cancellazione',
            element: <CancellationAirePresumedUnavailabiltyPage />,
          },
        ],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];
